export const SECTION_TITLE_PRICE_HISTORY = 'Price History';
export const SECTION_TITLE_SUBMODEL_INFO = 'Submodel Pricing Information';
export const SECTION_TITLE_DEALER_DETAIL = 'New Car Dealer Details';
export const SECTION_TITLE_DISTRIBUTOR = 'New Car Distributor Information';

export const NO_PRICE_HISTORY = 'No Price History Records Available.';
